import classNames from "classnames";
import React from "react";
export const SkipButton = ({
  onSkip,
  children,
}: {
  onSkip: () => void;
  children: React.ReactNode;
}) => {
  return (
    <div
      onClick={onSkip}
      className={classNames(
        "cw-bg-default cw-bg-opacity-70 cw-w-full cw-absolute cw-bottom-[3rem] cw-mb-4 cw-pt-2 cw-z-[1]",
        "cw-body-lg cw-text-muted cw-cursor-pointer cw-text-center",
        "hover:cw-underline",
      )}
    >
      {children}
    </div>
  );
};
